// Renders the "Recently viewed products" tab of the Featured Collections section by re-fetching this
// section with a search query built from the products tracked in localStorage (same technique as the
// dedicated Recently Viewed Products section), then swapping in the resolved product cards.
//
// Unlike the dedicated section's <recently-viewed-products> element (which removes its whole enclosing
// section when there is nothing to show), this element only removes its own tab - so the other
// collection tabs in this section stay intact for visitors with no browsing history yet.
class FeaturedCollectionsRecentlyViewed extends HTMLElement {
  #isLoaded = false;

  connectedCallback() {
    this.#loadProducts();
  }

  get #searchQueryString() {
    const items = new Set(JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]'));

    if (this.hasAttribute('exclude-id')) {
      items.delete(parseInt(this.getAttribute('exclude-id'), 10));
    }

    return Array.from(items.values(), (item) => `id:${item}`)
      .slice(0, parseInt(this.getAttribute('products-count'), 10))
      .join(' OR ');
  }

  #removeTab() {
    const tabItem = this.closest('.featured-collections-carousel__item');

    if (!tabItem) return;

    const tabList = tabItem.parentElement;
    const tabIndex = tabList ? Array.from(tabList.children).indexOf(tabItem) : -1;
    const navButton = tabIndex > -1 ? tabItem.closest('.section-stack')?.querySelectorAll('.featured-collections-navigation button')[tabIndex] : null;

    tabItem.remove();
    navButton?.remove();
  }

  async #loadProducts() {
    if (this.#isLoaded) return;
    this.#isLoaded = true;

    const query = this.#searchQueryString;

    if (query === '') {
      this.#removeTab();
      return;
    }

    const section = this.closest('.shopify-section');
    const sectionId = section.id.replace('shopify-section-', '');
    const url = `${Shopify.routes.root}search?type=product&q=${query}&section_id=${sectionId}`;
    const response = await fetch(url, { priority: 'low' });
    const tempDiv = new DOMParser().parseFromString(await response.text(), 'text/html');
    const recentlyViewedElement = tempDiv.querySelector('featured-collections-recently-viewed');

    if (recentlyViewedElement && recentlyViewedElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(recentlyViewedElement, true).childNodes);
    } else {
      this.#removeTab();
    }
  }
}

if (!window.customElements.get('featured-collections-recently-viewed')) {
  window.customElements.define('featured-collections-recently-viewed', FeaturedCollectionsRecentlyViewed);
}
